export default [
  {
    path: '/oficinas-treinamentos',
    component: () =>
      import('@/pages/AtividadeColetiva/OficinasTreinamentos.vue'),
  },
  {
    path: '/oficinas-treinamentos-facilitador',
    component: () => import('@/pages/AtividadeColetiva/Listagem.vue'),
  },
  {
    path: '/oficinas-treinamentos-participante',
    component: () => import('@/pages/AtividadeColetiva/Profissionais.vue'),
  },
  {
    path: '/oficinas-treinamentos-certificados',
    component: () => import('@/pages/AtividadeColetiva/Certificados.vue'),
  },
  {
    path: '/oficinas-treinamentos-profissional',
    component: () => import('@/pages/AtividadeColetiva/Profissionais.vue'),
  },
  {
    path: '/ficha-atividade-coletiva',
    component: () => import('@/pages/AtividadeColetiva/Template.vue'),
    children: [
      {
        path: '/ficha-atividade-coletiva',
        component: () => import('@/pages/AtividadeColetiva/index.vue'),
      },
    ],
  },
  {
    path: '/oficinas-treinamentos/avaliacao-treinamento',
    component: () => import('@/pages/AvaliacaoTreinamentoAnalise/Template.vue'),
    children: [
      {
        path: '/oficinas-treinamentos/avaliacao-treinamento',
        component: () =>
          import('@/pages/AvaliacaoTreinamentoAnalise/Index.vue'),
      },
    ],
  },
]
